export enum ScoreType {
  A2 = "A2",
  A1 = "A1",
  B1 = "B1",
  C1 = "C1",
  D1 = "D1"
}

const scoreTypeMap: Record<string, ScoreType> = {
  A1: ScoreType.A1,
  A2: ScoreType.A2,
  B1: ScoreType.B1,
  C1: ScoreType.C1,
  C2: ScoreType.C1,
  D1: ScoreType.D1,
  E1: ScoreType.D1
};

export const standardizeScoreType = (score: string | number): ScoreType => {
  // If score is a number, use getScoreType to translate into a letter.
  if (typeof score === "number") {
    return getScoreType(score);
  }
  return scoreTypeMap[score] ?? ScoreType.A1;
};

// get Score Type
export const getScoreType = (score: number): ScoreType => {
  if (score > 75) {
    return ScoreType.A1;
  }
  if (score > 50) {
    return ScoreType.B1;
  }
  if (score > 25) {
    return ScoreType.C1;
  }
  return ScoreType.D1;
};
